module.exports = __webpack_public_path__ + "static/img/pic_zqgj.d1a55708.png";